// @ts-check
import Rule from './Rule';

export default Rule;
